import { Link } from 'react-router-dom';
import { ArrowUpRight, Gift, Heart, Headphones, Compass, Snowflake } from 'lucide-react';

const LONDON = 'https://images.unsplash.com/photo-1636975033611-935e3f5efaa1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400';
const AURORA = 'https://images.pexels.com/photos/27206144/pexels-photo-27206144.jpeg?auto=compress&cs=tinysrgb&w=1200';

const Tile = ({ to, testId, className = '', children }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group relative overflow-hidden rounded-3xl p-6 sm:p-7 flex flex-col justify-end min-h-[220px] ring-1 ring-black/5 transition-transform duration-300 hover:-translate-y-1 ${className}`}
  >
    {children}
    <ArrowUpRight className="absolute top-5 right-5 w-5 h-5 opacity-60 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:opacity-100" />
  </Link>
);

const PhotoTile = ({ img, to, testId, tag, TagIcon, title, body, className = '' }) => (
  <Tile to={to} testId={testId} className={`text-white bg-stone-900 ${className}`}>
    <img src={img} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-stone-950/90 via-stone-950/40 to-transparent" />
    <div className="relative">
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/15 backdrop-blur text-[11px] font-bold">
        <TagIcon className="w-3.5 h-3.5" /> {tag}
      </span>
      <h3 className="mt-3 text-2xl sm:text-3xl font-bold leading-tight font-serif">{title}</h3>
      <p className="mt-2 text-sm text-white/80 max-w-md">{body}</p>
    </div>
  </Tile>
);

const TextTile = ({ to, testId, Icon, tone, title, body }) => (
  <Tile to={to} testId={testId} className={tone}>
    <Icon className="w-8 h-8 mb-auto" />
    <h3 className="mt-6 text-xl font-bold leading-tight font-serif">{title}</h3>
    <p className="mt-1.5 text-sm opacity-80">{body}</p>
  </Tile>
);

// "Novedades" de la portada: bento con las últimas funciones y rutas.
export const WhatsNew = () => (
  <section className="py-20 lg:py-24" data-testid="landing-whats-new">
    <div className="max-w-6xl mx-auto px-5 sm:px-8">
      <p className="text-[11px] font-bold uppercase tracking-[3px] text-rose-500">Novedades</p>
      <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight font-serif max-w-2xl">
        Lo último en Tovías: viajes para soñar, regalar y escuchar
      </h2>
      <div className="mt-10 grid gap-5 md:grid-cols-6">
        <PhotoTile
          img={LONDON} to="/funciones/viaje-regalo" testId="whats-new-gift" tag="Viaje Regalo" TagIcon={Gift}
          title="Regala un viaje envuelto, con cuenta atrás"
          body="Prepara el viaje, elige cuándo se abre y deja pistas. Quien lo recibe lo desenvuelve en su móvil."
          className="md:col-span-4 md:row-span-2 min-h-[320px] md:min-h-[460px]"
        />
        <div className="md:col-span-2">
          <TextTile
            to="/funciones/lista-de-deseos" testId="whats-new-wishlist" Icon={Heart}
            tone="bg-rose-50 text-rose-950 h-full"
            title="Tu lista de deseos"
            body="Guarda los viajes que sueñas y compártela: tu carta a los Reyes viajera."
          />
        </div>
        <div className="md:col-span-2">
          <TextTile
            to="/funciones/audioguias" testId="whats-new-audio" Icon={Headphones}
            tone="bg-teal-900 text-white h-full"
            title="Audioguías que suenan a viaje"
            body="Dos voces, Tov y Vías, con efectos y ambiente de cada lugar."
          />
        </div>
        <PhotoTile
          img={AURORA} to="/rutas" testId="whats-new-routes" tag="Rutas de invierno" TagIcon={Snowflake}
          title="Laponia bajo las auroras y Londres mágico"
          body="Iglús de cristal, Hogwarts bajo la nieve y la Navidad londinense, con audioguías."
          className="md:col-span-4"
        />
        <div className="md:col-span-2">
          <TextTile
            to="/inspirate" testId="whats-new-inspire" Icon={Compass}
            tone="bg-amber-100 text-amber-950 h-full"
            title="Inspírate"
            body="Destinos, lugares y rutas para elegir tu próximo viaje."
          />
        </div>
      </div>
    </div>
  </section>
);
